import CancelIcon from "@mui/icons-material/Cancel";
import {
    Box,
    InputAdornment,
    TextField,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {
    FilterPanelTrigger,
    GridFilterListIcon,
    GridSearchIcon,
    QuickFilter,
    QuickFilterClear,
    QuickFilterControl,
    QuickFilterTrigger,
    Toolbar,
    ToolbarButton,
} from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";

/**
 * The toolbar for the clause library table for filter actions
 */
export const ClauseLibraryTableToolbar = () => {
    const [expanded, setExpanded] = useState(true);
    const theme = useTheme();
    const isListView = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        // On mobile, the quick filter is not expanded by default
        if (isListView) {
            setExpanded(false);
        } else {
            setExpanded(true);
        }
    }, [isListView]);

    return (
        <Toolbar style={{ borderBottom: "none" }}>
            {/* Filters Button */}
            <FilterPanelTrigger render={<ToolbarButton />}>
                <GridFilterListIcon fontSize="small" color="primary" />
            </FilterPanelTrigger>
            <Box flexGrow={1} />
            {/* Quick Filter */}
            <QuickFilter
                expanded={expanded}
                onExpandedChange={(expandedChanged) => {
                    if (isListView) {
                        setExpanded(expandedChanged);
                    }
                }}
                style={{
                    display: "grid",
                    alignItems: "center",
                    marginLeft: "auto",
                }}
            >
                <QuickFilterTrigger
                    render={(triggerProps) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const { ref, ...restTriggerProps } = triggerProps;
                        return (
                            <ToolbarButton
                                {...restTriggerProps}
                                disabled={expanded}
                                style={{
                                    gridArea: "1 / 1",
                                    width: "min-content",
                                    height: "min-content",
                                    zIndex: 1,
                                    opacity: expanded ? 0 : 1,
                                    pointerEvents: expanded ? "none" : "auto",
                                    transition: theme.transitions.create([
                                        "opacity",
                                    ]),
                                }}
                            >
                                <GridSearchIcon fontSize="small" />
                            </ToolbarButton>
                        );
                    }}
                />
                <QuickFilterControl
                    render={({ ref, ...controlProps }, state) => (
                        <TextField
                            {...controlProps}
                            inputRef={ref}
                            size="small"
                            variant={"standard"}
                            placeholder="Search..."
                            sx={{
                                gridArea: "1 / 1",
                                overflowX: "clip",
                                width: expanded ? (isListView ? 200 : 260) : 36,
                                opacity: expanded ? 1 : 0,
                                transition: theme.transitions.create([
                                    "width",
                                    "opacity",
                                ]),
                            }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <GridSearchIcon fontSize="small" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: state.value ? (
                                        <InputAdornment position="end">
                                            <QuickFilterClear
                                                edge="end"
                                                size="small"
                                                aria-label="Clear search"
                                            >
                                                <CancelIcon fontSize="small" />
                                            </QuickFilterClear>
                                        </InputAdornment>
                                    ) : null,
                                    ...controlProps.slotProps?.input,
                                },
                                ...controlProps.slotProps,
                            }}
                        />
                    )}
                />
            </QuickFilter>
        </Toolbar>
    );
};
